import React, { useEffect, useState } from "react";
import "./Header.scss";
import { useHistory } from "react-router-dom";
import { sessionService } from "../../Utils/SessionService";
import { Button, Dropdown, Menu, Modal, DatePicker } from "antd";
import logo from "../../../Assets/images/CPCB_logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser, faGear } from "@fortawesome/free-solid-svg-icons";
import { LogoutOutlined, DownloadOutlined } from "@ant-design/icons";
import { ServiceUtils } from "../../Utils/ServiceUtils";
import { alertService } from "../../Utils/ToasterUtils";
import moment from "moment";
const { RangePicker } = DatePicker;

export default function Header(props) {
  const [showReportsModal, setShowReportsModal] = useState(false);
  const [calenderValue, setCalenderValue] = useState(null);
  const [isError, setIsError] = useState("");
  const history = useHistory();
  const userDetails = sessionService.getSession("cpcb-user");
  const menuItemsList = userDetails.role[0].toUpperCase() === "STATE" || userDetails.role[0].toUpperCase() === "ALL" || userDetails.role[0].toUpperCase() === "STATE_ADMIN"  ?
    [
      {
        label: "Download Reports",
        key: "reports",
        icon: <DownloadOutlined />,
      },
      {
        label: "Logout",
        key: "logout",
        icon: <LogoutOutlined />,
      }
    ] :
    [
      {
        label: "Logout",
        key: "logout",
        icon: <LogoutOutlined />,
      },
    ]
  const handleClick = (el) => {
    if (el.key === "logout") {
      handleLogout();
    }
    if (el.key === "reports") {
      setShowReportsModal(true);
    }
  };

  let generateFile = (content, fileName) => {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(content);
    link.download = "complaints_report.xlsx";
    link.click();
  };

  const validate = () => {
    let isValid = true;
    if (!calenderValue || (calenderValue && (!calenderValue[1]["_i"] || !calenderValue[0]["_i"]))) {
      isValid = false;
      setIsError("Date range is required")
    }
    else{
      setIsError("")
    }
    return isValid;
  }

  useEffect(()=>{
    validate()
  },[calenderValue])

  const onDownloadReports = () => {
    const payload = {};

    const isValid = validate();

    if (isValid) {
      const tempEndDate = calenderValue[1]["_i"]
      const tempStartDate = calenderValue[0]["_i"]
      payload["to_date"] = tempEndDate;
      payload["from_date"] = tempStartDate;
      payload['state_name'] = userDetails.org;
      const encodedPayload = btoa(JSON.stringify(payload));
      ServiceUtils.postRequest("download-reports", encodedPayload, true, undefined, "blob").then((_response) => {
        let decodedData;
        if (_response?.data) {
          generateFile(_response.data);
          setShowReportsModal(false)

        }
        if (_response.status === 200) {
          if (decodedData?.status === "failed") {
            alertService.error("Download Error")
          }
        } else {
          alertService.error(
            decodedData?.data?.message ||
            decodedData?.message ||
            "Internal Server Error"
          );
        }
      });
    }
  }

  const handleLogout = () => {
    let payload;
    if (userDetails) payload = {};
    const encodedPayload = btoa(JSON.stringify(payload));
    ServiceUtils.postRequest("userLogout", encodedPayload).then((_response) => {
      let decodedData;
      if (_response?.data) {
        decodedData = JSON.parse(atob(_response.data));
      }
      if (_response.status === 200) {
        if (decodedData?.status === "failed") {
          alertService.error("Logout Error")
        } else {
          history.push("/logout");
        }
      } else {
        alertService.error(
          decodedData?.data?.message ||
          decodedData?.message ||
          "Internal Server Error"
        );
      }
    });
  };

  const onClickSettings = () => {
    history.push("/admin-settings");
  };

  const menu = (
    <Menu
      onClick={handleClick}
      items={menuItemsList}
    />
  );


  const disabledDate = (current) => {
    // Can not select days after today
    return current && current > moment().endOf('day');
  };
  const handleDatePicker = (date, dateString) => {
    if (dateString && dateString[0].length && dateString[1].length) {
      setCalenderValue([moment(dateString[0], "YYYY-MM-DD"), moment(dateString[1], "YYYY-MM-DD")])
    }
    else {
      setCalenderValue(null)
    }
  };

  return (
    <div className="header-main" data-test="header-container">
      <div className="company-text" >
        <img src={logo} className="header-logo" />
        <p className="portal-name">
          {userDetails?.role[0].toUpperCase()} - Single Use Plastic Complaint
          Portal
        </p>
      </div>
      <div className="right-menu">
        {/* <FontAwesomeIcon
          icon={faGear}
          className="settings"
          onClick={onClickSettings}
        /> */}
        <Dropdown overlay={menu} trigger={["click"]}>
          <Button type="text" className="user-info-btn">
            <div className="user-info">
              <div className="info">
                <FontAwesomeIcon icon={faCircleUser} className="profile-pic" />
                <div className="text">
                  <div className="name">{userDetails?.name}</div>
                  {/* <div className="name">{userDetails?.name}</div> */}
                  <div className="role">{`${userDetails?.org}`}</div>
                  {/* {userDetails?.[VARIABLES.userRole]?.map(el => titleCase(el.replace('_', ' '))).join(', ')} */}
                </div>
              </div>
            </div>
          </Button>
        </Dropdown>
      </div>
      <Modal
        title="Download Reports"
        visible={showReportsModal}
        onOk={onDownloadReports}
        onCancel={() => { setShowReportsModal(false) }}
        okButtonProps={{ type: 'primary' }}
        cancelButtonProps={{ type: 'default' }}
        okText="Download Reports"
        cancelText="Cancel"
        width={400}
        centered={true}
        disabled={true}
      >
        <div className="dateRange">Select the date range</div>
        <RangePicker disabledDate={disabledDate} defaultValue={calenderValue} onChange={handleDatePicker} />
        {isError && <div className="errorValidation">{isError}</div>}
      </Modal>
    </div >
  );
}
